<template>
  <v-data-iterator
    :headers="headers"
    :items="items"
    class="elevation-1"
    :loading="isLoading"
    sort-by="created"
    :sort-desc="true"
  >
    <template v-slot:default="props">
      <v-row>
        <template v-for="(item) in props.items">
          <v-col :key="item.id" cols="12" xl="3" lg="4" md="6" class=" d-flex align-stretch">
            <v-card class="mb-10">
              <v-card-title primary-title>
                {{item.collegeDocumentName}}
              </v-card-title>
              <v-card-text>
                <v-img contain :src="item.badge" />
                <div class="text-center text-h5 d-block">
                  {{ $$t('score') }}
                </div>
                <div class="text-center d-block">
                  <v-progress-circular
                    :value="item.score * 100"
                    color="teal"
                    :size="150"
                    :width="15">
                    {{ Math.round(item.score * 100) }}
                  </v-progress-circular>
                </div>
              </v-card-text>
              <v-card-actions v-if="!item.isCompleted">
                <v-btn
                  color="primary"
                  block
                  :to="{ name: 'membership-CollegeExam', query: { collegeExamId: item.id } }">
                  {{ $$t('continue') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </template>
  </v-data-iterator>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { mdiShieldStarOutline } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListCollegeExam',
  module: 'CollegeExam',
  mixins: [loading],
  data() {
    return {
      mdiShieldStarOutline,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('collegeExams', ['collegeExams']),
    ...mapState('collegeDocuments', ['collegeDocuments']),
    ...mapGetters('collegeExams', ['getCollegeDocumentName']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('collegeDocumentId'),
          value: 'collegeDocumentName',
        },
        {
          text: this.$$t('score'),
          value: 'score',
        },
        {
          text: this.$$t('created'),
          value: 'created',
        },
        {
          text: this.$$t('isCompleted'),
          value: 'isCompleted',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
    items() {
      const { collegeDocuments } = this;
      return this.collegeExams.map((cExam) => {
        const result = { ...cExam };
        const collegeDoc = collegeDocuments
          .find((c) => (c.id.toLowerCase() === cExam.collegeDocumentId.toLowerCase()));

        result.collegeDocumentName = collegeDoc?.title ?? `Not found (${cExam.collegeDocumentId})`;
        result.code = collegeDoc?.code ?? '';
        result.badge = collegeDoc?.badge ?? '';

        return result;
      });
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_allCollegeDocuments();
    await this.LOAD_collegeExams();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('collegeExams', ['LOAD_collegeExams', 'DELETE_collegeExam']),
    ...mapActions('collegeDocuments', ['LOAD_allCollegeDocuments']),
    formatScore(score) {
      return Math.round((score ?? 0) * 100);
    },
    /** Delete CollegeExam from the collection
     */
    async remove(CollegeExam) {
      this.isLoading = true;
      await this.DELETE_CollegeExam(CollegeExam);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# CollegeExam example

'''js
<CollegeExam />
'''
</docs>
